import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ group, nextGroup }) =>
    present(
      repository
        .editResourceGroup(group, nextGroup)
        .catch(() => Promise.reject({ group, nextGroup })),
    );
}

export type { Interactor };

export { createInteractor };
